import Button from 'components/core/button'
import { PaymentMethod } from 'interfaces/payment-method'
import Modal from 'lib/components/modals/modal'
import TextInput from 'lib/components/text-input/text-input'
import { SlashIcon } from 'lucide-react'
import { useState } from 'react'

interface BillingPaymentsModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  currentPaymentMethod: PaymentMethod
}

// TODO: Wire up
export default function BillingPaymentsModal({ open, setOpen, currentPaymentMethod }: BillingPaymentsModalProps) {
  const [cardholderName, setCardholderName] = useState('')
  const [cardNumber, setCardNumber] = useState('')
  const [expirationMonth, setExpirationMonth] = useState<number>()
  const [expirationYear, setExpirationYear] = useState<number>()
  const [cvc, setCvc] = useState<number>()

  return (
    <Modal open={open} setOpen={setOpen} size="md">
      <Modal.Header>Update Payment Method</Modal.Header>
      <Modal.Body>
        {currentPaymentMethod.object === 'card' && (
          <div key={currentPaymentMethod.id}>
            <h5 className="tw-m-0 tw-mb-4 tw-p-0 tw-text-lg tw-font-semibold">Credit Card</h5>
            <div className="tw-w-full">
              <div className="tw-flex tw-gap-2">
                <div className="tw-flex tw-flex-col">
                  <div className="tw-flex tw-flex-col">
                    <TextInput
                      label="Cardholder Name"
                      value={cardholderName}
                      name="cardholderName"
                      onChange={(e) => setCardholderName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="tw-flex tw-flex-col">
                  <TextInput
                    label="Card Number"
                    value={cardNumber}
                    name="cardNumber"
                    onChange={(e) => setCardNumber(e.target.value)}
                    maxLength={16}
                  />
                </div>
              </div>
              <div className="tw-flex tw-items-center tw-gap-2">
                <div className="tw-flex tw-flex-col">
                  <TextInput
                    label="MM"
                    value={expirationMonth}
                    name="expirationMonth"
                    maxLength={2}
                    className="tw-w-20 tw-appearance-none"
                    type="text"
                    onChange={(e) => numberInputValue(e, 2, setExpirationMonth)}
                  />
                </div>
                <SlashIcon className="tw-h-10 tw-w-10 tw-pt-4" />
                <div className="tw-flex tw-flex-col">
                  <TextInput
                    label="YYYY"
                    value={expirationYear}
                    name="expirationYear"
                    maxLength={4}
                    className="tw-appearance-textfield tw-w-24"
                    type="text"
                    onChange={(e) => numberInputValue(e, 4, setExpirationYear)}
                  />
                </div>
                <div className="tw-flex tw-flex-col">
                  <TextInput
                    label="CVC"
                    value={cvc}
                    name="cvc"
                    maxLength={3}
                    className="tw-w-20"
                    type="text"
                    onChange={(e) => numberInputValue(e, 3, setCvc)}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {currentPaymentMethod.object === 'bank_account' && (
          <div key={currentPaymentMethod.id} className="tw-flex tw-items-center tw-gap-2">
            <div>{currentPaymentMethod.bankName}</div>
            <div>•••••••••••• {currentPaymentMethod.last4}</div>
          </div>
        )}

        <Button color="lightGray" onClick={() => {}} className="tw-mt-4">
          Replace with {currentPaymentMethod.object === 'card' ? 'Bank Account' : 'Credit Card'}
        </Button>
      </Modal.Body>
      <Modal.Footer>
        <div className="tw-flex tw-w-full tw-justify-end tw-gap-2">
          <Button color="lightGray" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button color="purple" onClick={() => {}} disabled>
            Update
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

function numberInputValue(
  e: React.ChangeEvent<HTMLInputElement>,
  maxLength: number,
  setValue: (value: number | undefined) => void,
) {
  const value = e.target.value
  if (value.length <= maxLength && !isNaN(Number(value))) {
    setValue(Number(value) === 0 ? undefined : Number(value))
  }
}
